import Link from 'next/link';
import React from 'react';
import propTypes from 'prop-types';
import * as theme from '../constants/theme';
import ICONS from '../constants/icons';
import {Icon, Logo, MainMenu} from '.';

const {BACKGROUND_WHITE, TEXT, GUTTER} = theme;

class Header extends React.Component {
	constructor() {
		super();

		this.state = {
			isOpen: false
		};
	}

	handleClick = () => this.setState({
		isOpen: !this.state.isOpen
	});

	render = () => {
		const {mainMenu} = this.props;

		return (
			<header role='banner'>
				<div className='container'>
					<Link prefetch href='/'>
						<a>
							<Logo
								margin='0 20px 0 0'
								width='8rem'
							/>
						</a>
					</Link>
					<button type='button' className='MenuIcon' onClick={this.handleClick}>
						<Icon icon={this.state.isOpen ? ICONS.CLOSE : ICONS.MENU} size={32} color={TEXT}/>
					</button>
					<MainMenu items={mainMenu} open={this.state.isOpen}/>
				</div>
				<style jsx>
					{`
						header {
							color: ${TEXT};
							background-color: ${BACKGROUND_WHITE};
							height: 110px;
							position: fixed;
							z-index: 101;
							width: 100%;
							transition: top .5s ease-in;
							top: 0;
							left: 0;
							right: 0;
						}

						.container {
							display: flex;
							align-items: center;
							margin: 0 auto;
							max-width: 1280px;
							width: 100%;
							height: 100%;
						}

						.MenuIcon {
							margin-left: auto;
							margin-right: ${GUTTER};
							-webkit-backface-visibility: hidden;
							backface-visibility: hidden;
						}
					`}
				</style>
			</header>
		);
	}
}

Header.propTypes = {
	mainMenu: propTypes.array
};

export default Header;



// WEBPACK FOOTER //
// components/header.js